// What the assistant panel says while one of this module's tools is running
// («Buscando entre las máquinas…»), in the four languages.
//
// A contract with `backend/assistant.js`, like the analytics vocabulary is with
// `backend/analytics.js`: every tool registered there gets the key
// `assistant.tools.<registered name>` — the name the platform gives it, with the
// module in front — and this file holds that key. The English here is the
// same sentence as the tool's `label`, which is what the panel shows when a
// key is missing. platform/web/tests/assistantToolLabels.test.js checks both:
// a tool without its four sentences, or an English one that drifted from the
// backend label, fails the suite.

const toolLabels = {
  es: {
    work_orders_find_work_orders: 'Buscando entre las órdenes de trabajo',
    work_orders_work_order_file: 'Leyendo la orden de trabajo',
    work_orders_my_day: 'Leyendo tu día',
    work_orders_work_orders_summary: 'Sumando las órdenes de trabajo',
    work_orders_add_report: 'Escribiendo el parte de la orden',
    work_orders_create_order: 'Abriendo una orden de trabajo',
    work_orders_reschedule_order: 'Moviendo la orden de trabajo',
    work_orders_assign_order: 'Cambiando quién va',
    work_orders_set_order_priority: 'Cambiando la prioridad',
    work_orders_change_order_status: 'Cambiando el estado de la orden',
    work_orders_crew_day: 'Preparando el día de la cuadrilla',
  },
  ca: {
    work_orders_find_work_orders: 'Cercant entre les ordres de treball',
    work_orders_work_order_file: 'Llegint l’ordre de treball',
    work_orders_my_day: 'Llegint el teu dia',
    work_orders_work_orders_summary: 'Sumant les ordres de treball',
    work_orders_add_report: 'Escrivint el comunicat de l’ordre',
    work_orders_create_order: 'Obrint una ordre de treball',
    work_orders_reschedule_order: 'Movent l’ordre de treball',
    work_orders_assign_order: 'Canviant qui hi va',
    work_orders_set_order_priority: 'Canviant la prioritat',
    work_orders_change_order_status: 'Canviant l’estat de l’ordre',
    work_orders_crew_day: 'Preparant el dia de la colla',
  },
  en: {
    work_orders_find_work_orders: 'Looking through the work orders',
    work_orders_work_order_file: 'Reading the work order',
    work_orders_my_day: 'Reading your day',
    work_orders_work_orders_summary: 'Adding up the work orders',
    work_orders_add_report: 'Writing the report on the order',
    work_orders_create_order: 'Opening a work order',
    work_orders_reschedule_order: 'Moving the work order',
    work_orders_assign_order: 'Changing who goes',
    work_orders_set_order_priority: 'Changing the priority',
    work_orders_change_order_status: 'Changing the status of the order',
    work_orders_crew_day: 'Preparing the crew’s day',
  },
  fr: {
    work_orders_find_work_orders: 'Recherche parmi les ordres de travail',
    work_orders_work_order_file: 'Lecture de l’ordre de travail',
    work_orders_my_day: 'Lecture de votre journée',
    work_orders_work_orders_summary: 'Bilan des ordres de travail',
    work_orders_add_report: 'Rédaction du rapport de l’ordre',
    work_orders_create_order: 'Création d’un ordre de travail',
    work_orders_reschedule_order: 'Déplacement de l’ordre de travail',
    work_orders_assign_order: 'Changement de qui intervient',
    work_orders_set_order_priority: 'Changement de priorité',
    work_orders_change_order_status: 'Changement du statut de l’ordre',
    work_orders_crew_day: 'Préparation de la journée de l’équipe',
  },
}

/** The module's catalogue with its tool labels hung from `assistant.tools`, locale by locale. */
export function withToolLabels(base) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      assistant: {
        ...catalogue.assistant,
        tools: { ...catalogue.assistant?.tools, ...toolLabels[locale] },
      },
    }
  }
  return merged
}

export default toolLabels
